import Base from './Base.svelte'
import Heading from './Heading.svelte'
import Image from './Image.svelte'
import Subheading from './Subheading.svelte'
import SuperHeading from './SuperHeading.svelte'

export default { Base, Heading, Subheading, SuperHeading, Image }
